import ProductFilter from "./modules/Store/ProductFilter";
import ProductGallery from "./modules/Store/ProductGallery";
import ProductEdit from "./modules/Store/ProductEdit";

jQuery(function(){
    ProductGallery.bind();
    ProductFilter.bind();
    ProductEdit.bind();
});
